import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsAddToListButtonTappedParams = {
  trail_id: number;
};

/**
 * The user taps the add to list button on the trail details page (web only).
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - the trail id of the item the user selected
 */
const logTrailDetailsAddToListButtonTapped = ({ trail_id }: logTrailDetailsAddToListButtonTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details add to list button tapped', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsAddToListButtonTapped;
